import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCheckIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.84194 13L0 6.5L1.52581 4.80209L5.84194 9.60419L14.4742 0L16 1.69791L5.84194 13Z", fill: "white" }));
const ForwardRef = forwardRef(SvgWhiteCheckIcon);
export { ForwardRef as ReactComponent };
